import React from "react";
import { observer } from "mobx-react";
import Utils from "Utils/utils";
import { ReactComponent as ConfigureInboxIcon } from "Assets/Settings/configureInbox.svg";
import { ReactComponent as DeleteIcon } from "Assets/Settings/deleteInboxIcon.svg";
import { ReactComponent as SpamCountIcon } from "Assets/Settings/spamCount.svg";
import Button from "Components/common/Button";
import { whatsAppReplyState } from "./state";
import WhatsAppProfileCard from "./common/WhatsAppProfileCard";
import WhatsAppMetrics from "./common/WhatsAppMetrics";
import ConnectedWhatsAppLoader from "./common/ConnectedWhatsAppLoader";
import { confirmationPopupState } from "Components/common/confirmationPopup";

const ConnectedWhatsAppList = observer(() => {
  const handleConfigureAction = data => {
    if (data?.status?.toLowerCase() === "disconnected") return;
    whatsAppReplyState.setConfigureData(data);
    whatsAppReplyState.setShowConfigure(true);
  };

  const deleteWaAccount = item => {
    whatsAppReplyState.deleteWhatsappAccount(item?.id);
  };

  const deleteCbk = item => {
    confirmationPopupState.setPopupValues({
      content:
        "Are you sure you want to remove this WhatsApp Account? All the scheduled tasks from this account will be suspended.",
      actionBtnText: "Yes",
      cancelBtnText: "No",
      callback: () => {
        deleteWaAccount(item);
      },
      loadingMsg: "Deleting account. Please wait..."
    });
    confirmationPopupState.setShowPopup(true);
  };

  const handleReconnect = async e => {
    Utils.preventDefaultFn(e);
    const popup = window.open("about:blank", "_blank", "width=600,height=700");
    const url = await whatsAppReplyState.getWhatsappAuthUrl();
    if (url && popup) {
      popup.location.href = url;
    } else if (popup) {
      popup.close();
    }
  };

  return (
    <div className="connectedLinkedInList">
      {!whatsAppReplyState?.waDataLoading
        ? whatsAppReplyState?.waAccounts?.accounts?.length > 0 &&
          whatsAppReplyState?.waAccounts?.accounts.map((item, index) => {
            const isDisconnected =
              item?.status?.toLowerCase() === "disconnected";
            return (
              <div
                className="connectedLinkedInCard"
                key={item?.id || index}
                onClick={() => handleConfigureAction(item)}
              >
                <WhatsAppProfileCard {...item} />
                <WhatsAppMetrics {...item} />
                {isDisconnected && (
                  <div className="statusBtn">
                    <div className="linkedInwarmingEnabledOrDisabledBtn errorBtn">
                      <Button
                        id="waConnectionFailedBtn"
                        name="waConnectionFailedBtn"
                        icon={false}
                        type="button"
                        btnText="Disconnected"
                        className="warmingError"
                        loader={false}
                        svg={<SpamCountIcon />}
                      />
                    </div>
                  </div>
                )}
                <div className="btnInboxActions">
                  {isDisconnected ? (
                    <span
                      className="reconnectBtn"
                      onClick={handleReconnect}
                    >
                      Reconnect
                    </span>
                  ) : (
                    <span
                      className="configureBtn"
                      onClick={() => handleConfigureAction(item)}
                    >
                      <ConfigureInboxIcon />
                    </span>
                  )}
                  <span
                    className="deleteInboxIcon"
                    onClick={e => {
                      Utils.preventDefaultFn(e);
                      deleteCbk(item);
                    }}
                  >
                    <DeleteIcon />
                  </span>
                </div>
              </div>
            );
          })
        : whatsAppReplyState?.waDataLoading && (
            <ConnectedWhatsAppLoader count={3} />
          )}
    </div>
  );
});

export { ConnectedWhatsAppList };
export default ConnectedWhatsAppList;
